import React from 'react';
import { BarChart3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
export const WelcomeSection = () => {
    const { t } = useTranslation('glossary');
    return (<div className="order-2 md:order-1">
            <div className="inline-flex items-center gap-2 rounded-full border border-slate-700 bg-slate-900/60 px-3 py-1 text-xs text-muted-foreground">
                <BarChart3 className="h-3.5 w-3.5 text-primary"/>
                <span>{t('sign_in.pill')}</span>
            </div>

            <h1 className="mt-3 text-3xl sm:text-4xl font-bold leading-tight">
                {t('sign_in.title.prefix')}{' '}
                <span className="bg-linear-to-r from-primary to-primary/60 bg-clip-text text-transparent">
                    {t('sign_in.title.brand')}
                </span>
            </h1>

            <p className="mt-3 text-muted-foreground max-w-prose">{t('sign_in.description')}</p>

            <ul className="mt-6 space-y-2 text-sm text-muted-foreground">
                <li>• {t('sign_in.bullets.trackingLinks')}</li>
                <li>• {t('sign_in.bullets.monitor')}</li>
                <li>• {t('sign_in.bullets.compare')}</li>
            </ul>
        </div>);
};
